module.exports = __webpack_public_path__ + "img/safety-badge.97663a7b.png";